/* HEADER Drawer */
document.addEventListener('click', function (e) {
  const target = e.target;
  if (!target || !target.classList) return;
  let clickedHandle = null;
  target.classList.forEach(cls => {
    if (cls.startsWith('HeaderDrawer-')) {
      clickedHandle = cls;
    }
  });
  if (!clickedHandle) return;
  document
    .querySelectorAll('[class*="HeaderDrawer-"].is-active')
    .forEach(el => el.classList.remove('is-active'));
  target.classList.add('is-active');
  document
    .querySelectorAll('details.cstm_menu_details[open]')
    .forEach(d => {
      const summary = d.querySelector('summary');
      if (summary) summary.click();
    });
  document.getElementById(clickedHandle)?.click();
});
document.addEventListener('toggle', function (e) {
  const details = e.target;
  if (!details.classList?.contains('cstm_menu_details')) return;
  document
    .querySelectorAll('.cstm_menu_details.is-active')
    .forEach(d => d.classList.remove('is-active'));
  if (details.hasAttribute('open')) {
    details.classList.add('is-active');
  }
});
document.addEventListener('toggle', function (e) {
  const drawer = e.target;
  if (!drawer.closest('header-drawer')) return;
  if (!drawer.hasAttribute('open')) return;
  setTimeout(() => {
    const firstHeader = document.querySelector('[class*="HeaderDrawer-"]');
    if (!firstHeader) return;
    firstHeader.click();
  }, 50);
});

(() => {
  const drawerDetails = document.querySelector('header-drawer details');
  if (!drawerDetails) return;
  let appliedForThisOpen = false;
  const openInnerMenu = () => {
    if (appliedForThisOpen) return;
    const firstDetails = drawerDetails.querySelector('.cstm_menu_details');
    if (!firstDetails) return;
    firstDetails.setAttribute('open', '');
    firstDetails.classList.add('menu-open');
    const allHeaders = drawerDetails.querySelectorAll('[class*="HeaderDrawer-"]');
    allHeaders.forEach(h => h.classList.remove('is-active'));
    const firstHeader = allHeaders[0];
    firstHeader?.classList.add('is-active');
    appliedForThisOpen = true;
  };
  const observer = new MutationObserver(() => {
    if (drawerDetails.classList.contains('menu-open')) {
      requestAnimationFrame(() => {
        requestAnimationFrame(openInnerMenu);
      });
    } else {
      // drawer close → reset flag
      appliedForThisOpen = false;
    }
  });
  observer.observe(drawerDetails, {
    attributes: true,
    attributeFilter: ['class']
  });
})();
/* HEADER Drawer */



//----404 page & cart page redirect to homepage----//
document.addEventListener("DOMContentLoaded", function() {
  var canonicalLink = document.querySelector('link[rel="canonical"]');
  if (canonicalLink.href.includes("404")) {
    window.location.href = "https://overlaysnow.com/";
  }
  if (canonicalLink.href == "https://overlaysnow.com/cart") {
    window.location.href = "https://overlaysnow.com/";
  }
});

//-----cart view all discount code starts-----//
const gridDiscount = document.querySelector('.show_discount_model');
const discountInput = document.querySelector('form #cart-discount');
const applyBtn = document.querySelector('form.cart-discount__form .cart-discount__button');

// Delegated event handling on document.body
document.body.addEventListener('click', (e) => {
  const viewBtn = e.target.closest('.view_all_coupon');
  const closeBtn = e.target.closest('.container_discount .close_model');
  const applyButton = e.target.closest('.apply_button');
  // Toggle discount model display
  if ((viewBtn || closeBtn)) {
    gridDiscount.classList.toggle('hidden');
  }
  // Handle discount code apply
});
$('body').on('click', '.apply_button', function() {
 const discountCode = $(this).parents('.discount_code_passage').find('.offer_code').text().trim();
 const errorMessage = $(this).parents('.discount_code_passage').find('.cart-discount__error');
  $('#cart-discount').val(discountCode);
    $('.cart-discount__button').trigger('click');
    setTimeout(function(){
    const errorMessageHidden = $('.show_add_discount_code .cart-discount__error').hasClass('hidden');
    if (!errorMessageHidden) {
      errorMessage.removeClass('hidden');
    }
  }, 1500)
});
//-----cart view all discount code ends-----//

//-----cart - comeplete your look code starts-----//
 $(document).ready(function () {
  const gridVariants = $('.cart_recommendations_variants_wrapper');
  const variantListContainer = $('#variant-list-container');
  const recommendedProducts = window.recommendedProducts;
  $('body').on('click', '.add-btn', function() {
    console.log("add-btn: ", this);
    const productId = $(this).data('product-id');
    const product = recommendedProducts[productId];

    if (product && variantListContainer.length) {
      variantListContainer.empty(); // Clear previous content

      product.variants.forEach(function (variant) {
        // const buttonLabel = variant.available ? 'Add to cart' : 'Sold out';
        // const buttonLabel = variant.available ? 'Add to cart' : 'Sold out';
        let buttonLabel;
        let preorderInput = '';
        if (variant?.metafields?.custom?.eligible_for_preorder) {
          buttonLabel = 'Pre Order';
          preorderInput = `
            <input 
              type="hidden" 
              name="properties[Type]" 
              value="Preorder"
            >
          `;
        } else {
          buttonLabel = variant.available ? 'Add to cart' : 'Sold out';
          preorderInput = '';
        }
        const addedLabel = 'Added';
        const disabledAttr = variant.available ? '' : 'disabled';
        const variantHTML = `
          <div class="item-upsell" data-variant-id="${variant.id}" data-variant-title="${variant.title}">
            <div class="product-main-content">
              <div class="img">
                <img src="${product.featured_image}" alt="${product.title}">
              </div>
              <div class="details">
                <span class="sidecart-product-title">${product.title}</span>
                <div class="variant-title">
                  <span class="variant-title-element">${variant.title}</span>
                </div>
              </div>
            </div>
            <div class="item-price">
              <span>${variant.price}</span>
              <div class="quantity-handler-wrapper hidden">
                <div class="quantity-handler">
                  <span id="reduce-quantity">-</span>
                  <input name="quantity" type="number" class="item-quantity" value="1" min="1" step="1" inputmode="numeric">
                  <span id="increase-quantity">+</span>
                </div>
              </div>
              <product-form-component
                data-product-id="${variant.id}"
                data-product-url="${product.url}"
                on:submit="/handleSubmit"
              >
              <form method="post" action="/cart/add">
                <input type="hidden" name="id" value="${variant.id}">
                ${preorderInput}
                <button
                  id="${variant.id}"
                  type="submit"
                  name="add"
                  class="button add-to-cart-button variant-atc"
                  ${disabledAttr}
                >
                  <span class="add-to-cart-text">${buttonLabel}</span>                 
                  <span aria-hidden="true" class="add-to-cart-text--added" style="display:none;">
                    <span class="svg-wrapper add-to-cart-icon--added">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-checkmark">
                        <path d="M4.75439 10.7485L7.68601 14.5888C7.79288 14.7288 7.84632 14.7988 7.91174 14.8242C7.96907 14.8466 8.03262 14.8469 8.09022 14.8253C8.15596 14.8007 8.21026 14.7314 8.31886 14.5927L15.2475 5.74658" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </span>
                    <span>${addedLabel}</span>
                  </span>
                </button>
              </form>
              </product-form-component>
            </div>
          </div>
        `;
        variantListContainer.append(variantHTML);

        const newlyAddedBtn = variantListContainer.find(`.variant-atc#${variant.id}`);
        if (newlyAddedBtn.length) {
          newlyAddedBtn.on('click', function () {
            const btn = $(this);
            btn.addClass('atc-added');
            const addToCartText = btn.find('.add-to-cart-text');
            const addedText = btn.find('.add-to-cart-text--added');

            if (addToCartText.length && addedText.length) {
              addToCartText.hide();
              addedText.css('display', 'inline-flex');
              setTimeout(function () {
                btn.removeClass('atc-added');
                addToCartText.show();
                addedText.hide();
              }, 2000);
            }
          });
        }
      });

      gridVariants.removeClass('hidden');
    }
  });

  $('.variants_close_model').on('click', function () {
    gridVariants.addClass('hidden');
  });
});
//-----cart - comeplete your look code ends-----//

//-----cart - gift wrap code starts-----//
$(document).ready(function () {
  $(document).on('input', function (e) {
    const targets = [
      {
        checkboxId: "gift-checkbox",
        variantId: 47383490265340
      },
      {
        checkboxId: "gift-checkbox2",
        variantId: 47383490101500
      }
    ];

    targets.forEach(({ checkboxId, variantId }) => {
      const $checkbox = $('#' + checkboxId);
      if (!$checkbox.length) return;

      $('.cstm_add_to_cart').each(function () {
        $(this).off('click').on('click', function () {
          if ($checkbox.prop('checked')) $checkbox.click();
        });
      });

      if (e.target.id !== checkboxId) return;

      const $get_cart = $('#cstm_cart_drawer');

      const GiftWrapAdd = () => {
        console.log('checked')
        $get_cart.addClass("disable_cart");
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          contentType: 'application/json',
          data: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1
            }]
          }),
          success: () => {
            refreshCartAndPrice(variantId);
          },
          error: (err) => {
            console.error("Add error:", err);
          }
        });
      };

      const GiftWrapRemove = () => {
        console.log('unchecked')
        $get_cart.addClass("disable_cart");
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          contentType: 'application/json',
          data: JSON.stringify({
            id: `${variantId}`,
            quantity: 0
          }),
          success: () => {
            refreshCartAndPrice(variantId);
          },
          error: (err) => {
            console.error("Remove error:", err);
          }
        });
      };

      const Debounce = (fn, delay) => {
        let timer;
        return () => {
          clearTimeout(timer);
          timer = setTimeout(fn, delay);
        };
      };

      const GiftWrapAddDebounced = Debounce(GiftWrapAdd, 1000);
      const GiftWrapRemoveDebounced = Debounce(GiftWrapRemove, 1000);

      $.getJSON('/cart.js', function (cartData) {
        const inCart = cartData.items.some(item => item.id === variantId);

        if (!inCart && $checkbox.prop('checked')) {
          GiftWrapAddDebounced();
          $checkbox.prop('disabled', true);
          setTimeout(() => {
            $checkbox.prop('disabled', false);
          }, 1000);
        }

        if (inCart && !$checkbox.prop('checked')) {
          GiftWrapRemoveDebounced();
          $checkbox.prop('disabled', true);
          setTimeout(() => {
            $checkbox.prop('disabled', false);
          }, 1000);
        }
      });

      // function refreshCartAndPrice(targetVariantId) {
      //  // var cart_total = $('.cart__total-value').attr('value');
      //  // const numericValue = cart_total.replace(/[^\d.]/g, '').split('.')[0];
      //  // var total_Price = parseInt(numericValue) + 50;
      //  //  $('.cart__total-value').text('₹ ' + total_Price + '.00');
      //   const $oldCardWrapper = $('.cart-items__wrapper .cart-items__table');
      //   const $oldCartSummary = $('.cart__summary-totals');

      //   $.get('/cart?section_id=main-cart', function (result) {
      //     const html = $.parseHTML(result);
      //     const $html = $(html);
      //     const $newCardWrapper = $html.find('.shopify-section');
      //     const $newCartSummary = $html.find('.shopify-section .cart__summary-totals');         
      //     // $oldCardWrapper.html($newCardWrapper.html());
      //     // $oldCartSummary.html($newCartSummary.html());          
      //   });
      //   console.log('3333')
      // }


  function refreshCartAndPrice(targetVariantId) {
    const oldCardWrapper = document.querySelector('.cart-items__wrapper .cart-items__table');
    const oldCartSummary = document.querySelector('.cart__summary-totals');
  
    fetch('/cart?section_id=main-cart')
      .then(response => response.text())
      .then(result => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(result, 'text/html');
        const newCardWrapper = doc.querySelector('.shopify-section .cart-items__wrapper .cart-items__table');
        const newCartSummary = doc.querySelector('.shopify-section .cart__summary-totals');
          oldCardWrapper.innerHTML = newCardWrapper.innerHTML;
          oldCartSummary.innerHTML = newCartSummary.innerHTML;
      })
  }
    });
  });
});
//-----cart - gift wrap code ends-----//
